import {
  ProductsCategoriesStore,
  ProductsCategoriesActions,
  ProductsCategoriesCountActions,
} from './types';

export const defaultState: ProductsCategoriesStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  productCategories: [],
};

const reducer = (
  state: ProductsCategoriesStore = defaultState,
  action: { type: ProductsCategoriesActions | ProductsCategoriesCountActions; payload?: any }
): ProductsCategoriesStore => {
  switch (action.type) {
    case ProductsCategoriesActions.FetchCategoriesBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        productCategories: [],
        error: null,
      };
    }
    case ProductsCategoriesActions.FetchCategoriesError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case ProductsCategoriesActions.FetchCategoriesSuccess: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: null,
        productCategories: [...action.payload.productCategories],
      };
    }
    case ProductsCategoriesCountActions.FetchCategoriesBegin: {
      return {
        ...state,
        // isLoading: true,
        // isLoaded: false,
        error: null,
      };
    }
    case ProductsCategoriesCountActions.FetchCategoriesError: {
      return {
        ...state,
        // isLoading: false,
        // isLoaded: true,
        error: action.payload,
      };
    }
    case ProductsCategoriesCountActions.FetchCategoriesSuccess: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: null,
        productCategories: state.productCategories.map((cat, idx) => ({
          ...cat,
          count: action.payload.count[idx],
        })),
      };
    }

    default: {
      return state;
    }
  }
};
export default reducer;
